module.exports = __webpack_public_path__ + "img/stock3.8a4579a6.png";